/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TooltipButton } from '../../../../../../../../common/react/components/tooltip-button';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { getGlossaryDefinitionFromColumnId } from '../utils/get-glossary-definition-from-column-id';

export const TableHead = ( { headerGroup } ) => {
    // @ts-ignore
    const { render } = PULSE.app.templating;

    return (
        <thead>
            <tr { ...headerGroup.getHeaderGroupProps() } className="stats-leaders-table__header-row">
                { headerGroup.headers.filter( column => ![ 'position', 'team' ].includes( column.id ) ).map( ( column, columnIndex ) => {
                    const { onClick, ...headerProps } = column.getHeaderProps( column.getSortByToggleProps() );
                    const cellContent = column.render( 'Header' );
                    const fullName = getTranslation( `label.statsLeaders.${ column.id }.name` );

                    const glossaryDefinition = getGlossaryDefinitionFromColumnId( column.id );
                    
                    return (
                        <th
                            { ...headerProps }
                            className={ classnames( 'stats-leaders-table__header-cell', {
                                'stats-leaders-table__header-cell--sorted': column.isSorted,
                                'u-text-left': column.id === 'player'
                            } ) }
                            scope="col"
                        >
                            <TooltipButton
                                externalTooltip
                                suppressFocusStyles
                                primaryTooltipContent={
                                    <strong style={{ fontWeight: 500 }}>{ fullName }</strong>
                                }
                                secondaryTooltipContent={
                                    ( () => {
                                        if ( glossaryDefinition ) {
                                            return (
                                                <div className="stats-leaders-table-header-tooltip-secondary">
                                                    <div className='stats-leaders-table-header-tooltip-secondary__border' />
                                                    <p>{ glossaryDefinition }</p>
                                                </div>
                                            );
                                        }
                                        return null;
                                    } )()
                                }
                                classNames={ {
                                    component: 'stats-leaders-table__header-cell-button-wrapper',
                                    button: 'stats-leaders-table__header-cell-button'
                                } }
                                onClick={ onClick }
                                disabled={ [ 'header_rank', 'header_player' ].includes( headerProps.key ) }
                                title={ `Sort by ${ fullName } ${ getNextSortDirection( column ) }` }
                                theme="dark"
                            >
                                { cellContent }
                                { /* The `columnIndex > 1` check is so that we ignore the Rank and Player columns because they don't need this. */ }
                                { columnIndex > 1 && column.isSorted && (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: render( {
                                                cssClass: classnames( 'stats-leaders-table__sort-icon', {
                                                    'stats-leaders-table__sort-icon--flipped': !column.isSortedDesc
                                                } ),
                                                name: 'dropdown'
                                            }, 'common.svg-icon' )
                                        } }
                                    ></span>
                                ) }
                            </TooltipButton>
                        </th>
                    );
                } ) }
            </tr>
        </thead>
    );
};

TableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired
};

const getNextSortDirection = column => {
    if ( !column.isSorted ) {
        return 'descending';
    }
    
    return column.isSortedDesc ?
        'ascending' :
        'descending';
};